import type { PortfolioInsightModalPayload } from "./types";

const INSIGHT_BODY =
  "Past your 15% guardrail by 23 percentage points. A typical NVDA correction (−30%) costs you ~$21,400 — wipes more than a full year of expected return on the remainder.";

/** Figma 88972 / 88100 — Harness copy contract baseline */
export const PORTFOLIO_INSIGHT_MOCK: PortfolioInsightModalPayload = {
  headerTitle: "Meet Ed",
  headline: "Read it. Three things stand out from your portfolio.",
  noticeLine: "Here's what I noticed:",
  insights: [
    {
      id: "insight-1",
      title: "One name decides your book",
      body: INSIGHT_BODY,
    },
    {
      id: "insight-2",
      title: "No hedge, no offset",
      body: INSIGHT_BODY,
    },
    {
      id: "insight-3",
      title: "No hedge, no offset",
      body: INSIGHT_BODY,
    },
  ],
  ctaLabel: "See the trackers",
};
